import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, MenuItem, Avatar, IconButton, Divider } from "@mui/material";
import { jwtDecode } from "jwt-decode";
import { MdArrowDropDown } from "react-icons/md";
// ADDED FaSearch for the new search bar
import { FaRegEdit, FaMobileAlt, FaSearch } from "react-icons/fa";
import { fetchCategories } from '../../API/Resources/fetchCategories';
import "./navbar.css";
import logo from "../../images/wedstra_logo.png";
import VendorDropdown from "./vendor_dropdown/vendor_dropdown";
import { HashLink } from 'react-router-hash-link';
import axiosInstance from "../../API/axiosInstance";

const Navbar = ({ token, userRole, setToken, setUserRole, onWriteReviewClick }) => {
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);
  const [user, setUser] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [categories, setCategories] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [allVendors, setAllVendors] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");


  const navigate = useNavigate();

  const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?q=${searchQuery.trim()}`);
      console.log("Searching for:", searchQuery);
    }
  };

  useEffect(() => {
    const fetchUsername = () => {
      if (!token) return null;

      try {
        const decodedToken = jwtDecode(token);
        const username = decodedToken.sub;
        setUser(username);
      }
      catch (e) {
        console.error(e);
      }
    }

    fetchUsername();
  }, [token, userRole]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("currentUser");
    localStorage.removeItem("role")
    setUserRole(null);
    setToken(null);
    navigate("/home");
  };

  const isActive = (path) => (location.pathname === path ? "nav-link active" : "nav-link");

  useEffect(() => {
    const fetchCategory = async () => {
      const cat = await fetchCategories();
      setCategories(cat);
    };

    const fetchAllVendors = async () => {
      setIsLoading(true);
      try {
        const response = await axiosInstance.get('/vendor/getVendors');
        const data = response.data;

        if (Array.isArray(data)) {
          setAllVendors(data);
        } else {
          console.error("Fetched data is not an array:", data);
          setAllVendors([]);
        }

      } catch (error) {
        console.error("Failed to fetch vendors:", error);
      }
      setIsLoading(false);
    };

    fetchCategory();
    fetchAllVendors();
  }, []);


  useEffect(() => {
    if (searchQuery.trim() === "") {
      setSuggestions([]);
      return;
    }

    const filteredSuggestions = allVendors.filter(vendor =>
      vendor.business_name?.toLowerCase().includes(searchQuery.toLowerCase())
    );

    setSuggestions(filteredSuggestions);
  }, [searchQuery, allVendors]);

  const handleSuggestionClick = (vendor) => {
    setSearchQuery(vendor.business_name);
    setSuggestions([]);
    navigate(`/vendor/${vendor.id}`);
    setSearchQuery("");
  };


  return (
    <>
      <div className="top-bar">
        <div className="container top-bar-container">
          <div className="nav-actions-container">
            <button className="btn nav-action-btn" onClick={onWriteReviewClick}>
              <FaRegEdit size={16} />
              <span>Write A Review</span>
            </button>
            <HashLink
              to="/#download-app-container"
              smooth
              className="btn nav-action-btn"
            >
              <FaMobileAlt size={16} />
              <span>Download App</span>
            </HashLink>
          </div>
        </div>
      </div>

      <nav className="navbar navbar-expand-lg" id="navbar">
        <div className="container">
          <Link className="navbar-brand m-0 p-0" to="/home">
            <img src={logo} alt="Wedstra Logo" width="60" />
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            aria-expanded={!isNavCollapsed ? true : false}
            aria-label="Toggle navigation"
            onClick={handleNavCollapse}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className={`${isNavCollapsed ? 'collapse' : ''} navbar-collapse`} id="navbarNav">
            <ul className="navbar-nav me-auto">
              {userRole !== 'VENDOR' && <li className="nav-item">
                <Link className={isActive("/")} to="/" onClick={handleNavCollapse}>Home</Link>
              </li>}
              {userRole !== 'VENDOR' && <li className="nav-item vendors-nav-item">
                <Link className={isActive("/vendors")} to="/vendors" onClick={handleNavCollapse}>Vendors</Link>
                <VendorDropdown />
              </li>}

              {userRole === 'VENDOR' && <li className="nav-item">
                <Link className={isActive("/vendor-dashboard")} to="/vendor-dashboard" onClick={handleNavCollapse}>Vendor dashboard</Link>
              </li>}

              {userRole === 'ADMIN' && <li className="nav-item">
                <Link className={isActive("/admin-dashboard")} to="/admin-dashboard" onClick={handleNavCollapse}>Admin dashboard</Link>
              </li>}
              <li className="nav-item">
                <Link className={isActive("/plans")} to="/plans" onClick={handleNavCollapse}>Plans</Link>
              </li>
              <li className="nav-item">
                <Link className={isActive("/blogs")} to="/blogs" onClick={handleNavCollapse}>Blogs</Link>
              </li>
              <li className="nav-item">
                <Link className={isActive("/about-us")} to="/about-us" onClick={handleNavCollapse}>About us</Link>
              </li>
            </ul>

            <div className="search-wrapper">
              <form className="search-container" onSubmit={(e) => e.preventDefault()}>
                <input
                  type="search"
                  className="search-input"
                  placeholder="Search for vendors..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  autoComplete="off"
                />
                <button type="submit" className="search-button">
                  <FaSearch />
                </button>
              </form>

              {searchQuery && (
                <ul className="suggestions-list">
                  {isLoading && <li className="suggestion-item-loading">Loading...</li>}
                  {!isLoading && suggestions.length > 0 && (
                    suggestions.map((vendor) => (
                      <li
                        key={vendor.id}
                        className="suggestion-item"
                        onClick={() => handleSuggestionClick(vendor)}
                      >
                        {vendor.business_name}
                      </li>
                    ))
                  )}
                  {!isLoading && suggestions.length === 0 && searchQuery && (
                    <li className="suggestion-item-loading">No results found.</li>
                  )}
                </ul>
              )}
            </div>

            {token ? (
              <div className="d-flex justify-content-center align-items-center">

                <section>
                  {userRole === "USER" &&
                    <ul className="navbar-nav me-auto">
                      <li className="nav-item">
                        <Link className={isActive("/wishlist")} to="/wishlist" onClick={handleNavCollapse}>Wishlist</Link>
                      </li>
                      <li className="nav-item">
                        <Link className={isActive("/cart")} to="/cart" onClick={handleNavCollapse}>Cart</Link>
                      </li>
                    </ul>}
                </section>


                <IconButton onClick={handleMenuOpen} id="dropdown-button">
                  <Avatar
                    style={{ width: "35px", height: "35px" }}
                    sx={{ bgcolor: "#CB0033", color: "#fff", fontSize: "1.2rem", fontWeight: "bold" }}
                    alt={user}
                  >
                    {user ? user.charAt(0).toUpperCase() : "U"}
                  </Avatar>
                  <MdArrowDropDown size={24} />
                </IconButton>

                <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                  <Divider />
                  <MenuItem component={Link} to="/tasks" onClick={handleMenuClose}><b>{user}</b></MenuItem>
                  {userRole === "USER" && <MenuItem component={Link} to="/tasks" onClick={handleMenuClose}>Tasks</MenuItem>}
                  {userRole === "USER" && <MenuItem component={Link} to="/expense-tracker" onClick={handleMenuClose}>Expense Tracker</MenuItem>}
                  <MenuItem component={Link} to="/profile" onClick={handleMenuClose}>Profile</MenuItem>

                  <Divider />

                  {/* For the logout button, ensure handleLogout also calls handleMenuClose */}
                  <MenuItem onClick={handleLogout} style={{ color: "red", fontWeight: "bold" }}>
                    Logout
                  </MenuItem>
                </Menu>
              </div>
            ) : (

              <section className="right-nav-section">
                <section className="login-section">
                  <span className="nav-item">
                    <Link className={isActive("/vendor-login")} to="/vendor-login" id="are-you-vendor">Are you a vendor?</Link>
                  </span>
                  <section id="login-buttons">
                    <button className="btn" id="login-btn">
                      <Link className={isActive("/user-login")} to="/user-login">Login</Link>
                    </button>
                    <button className="btn" id="signup-btn">
                      <Link className={isActive("/user-register")} to="/user-register">Sign up</Link>
                    </button>
                  </section>
                </section>
              </section>
            )}
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;